/**
 * スポットのstate
 */
const state = {
  // 地点リスト検索条件
  searchParams: {
    lang: 'ja',
    word: '',
    coord: '',
    area: '',
    address: '',
    category: '',
    tag: '',
    // (mapPage)現在の検索が特集スポットの場合、識別するための名称を入れる
    feature: null,
    // 周辺検索時に基準となる地点の名称
    spotName: '',
  },

  // おすすめスポット検索を利用しているか
  isRecommended: false,

  // 地点リスト検索結果（スポット）
  searchResultSpots: [],

  // 地点リスト検索結果（住所。スポットと同時に扱っています。増えたらaddressのstore作ってもいいかも）
  searchResultAddresses: [],

  // 検索中か
  isSearchingSpot: false,
  isSearchingAddress: false,

  // 検索エラーメッセージID
  errorMessageIdSpot: '',
  errorMessageIdAddress: '',

  // 地図に表示する地点リスト（地図のためににのみ使用している。mapのstoreに移動したい）
  resultSpots: [],

  // MapPageにて、一時的に選択されたスポット
  tapSpot: null,

  // 選択された地点の詳細情報
  spotDetail: {
    visible: false,
    spot: null,
    from: '',
  },

  // 地点検索結果リストでホバー中または地点詳細表示中の地点を設定
  focusedPoi: null,

  // 入力補助用にサジェストされたスポット一覧
  spotSuggestList: [],

  // サジェストから選ばれたスポット
  selectedSpotNameInSuggest: null,

  // スポット検索フィルタ設定保存用
  // trueでフィルタを有効
  filterShowArea: false,
  filterCurrentLocation: false,
  filterParking: false,
  filterWiFi: false,
  filterCreditCard: false,
  filterPlug: false,
  filterMultilingual: false,
  filterBarrierFree: false,
  filterVegan: false,
  filterHighLate: false,
  filterArticleSpot: false,
  filterNumSeats: 'unset',

  // ユーザーの現在位置
  currentLocation: {
    lat: null,
    lon: null,
  },
  poiSearchLog: null
};

export { state as default };
